import React, { useEffect, useState } from "react";
import SideList from "./sideBar/SideList";
import DarkMode from "./sideBar/DarkMode";
import logo from "../../assets/beeSQL_Logo_Stacked.png";
import UserDisplay from "./sideBar/UserDispaly";
import { useHistory } from "react-router-dom";

const SideBar = ({ companies, selectedCompanyId, onCompanyChange }) => {
  const [openList, setOpenList] = useState({ current: [] });
  const history = useHistory();

  const goHome = () => history.push("/");

  useEffect(() => {
    const hasRealCompany = (items) =>
      Array.isArray(items) &&
      items.some((item) => {
        const companyName = String(item?.company_name || "").toLowerCase();
        return !companyName.includes("add new location");
      });

    setOpenList((currentOpenList) => {
      if (currentOpenList.current.length > 0) return currentOpenList;

      return hasRealCompany(companies)
        ? { current: [9] }
        : currentOpenList;
    });
  }, [companies]);

  return (
    <div className="side-bar relative">
      <div className="side-bar-logo-wrapper">
        <img src={logo} alt="logo" width="32px" height="32px" />
      </div>

      <UserDisplay />

      <div className="side-list-inner-wrapper">
        <SideList
          label=""
          list={companies}
          current={selectedCompanyId}
          listN={9}
          openList={openList}
          onItemClick={(companyId) => {
            goHome();
            onCompanyChange(companyId);
          }}
          setOpenList={(value) => {
            goHome();
            setOpenList(value);
          }}
        />
      </div>

      <DarkMode />
    </div>
  );
};

export default SideBar;
